"use strict";

/* global google, installers */

var global_map;

/**
 * Slick configuration used for the List View results carousel.
 */
var FAIN_SLICK_OPTIONS = {
  autoplay: false,
  arrows: true,
  prevArrow: '<span class="fain__arrow--prev slider__arrow--prev"><svg width="52" height="38" viewBox="0 0 52 38" fill="none" xmlns="http://www.w3.org/2000/svg">' + '<path fill-rule="evenodd" clip-rule="evenodd" d="M20.9351 38L27.6883 38C27.537 31.8657 24.625 26.1196 19.7735 22.3929L19.7357 18.772L19.6871 17.2004L19.7735 15.6071C24.625 11.8804 27.537 6.13428 27.6883 -2.1254e-06L20.9351 -2.71578e-06C20.9351 8.60428 11.5345 15.6071 1.95765e-06 15.6071L1.36442e-06 22.3929C11.5345 22.3929 20.9351 29.3957 20.9351 38Z" fill="#D4C53B"/>' + '<path d="M52 21.7143L19.5844 21.7143L19.5844 16.2857L52 16.2857L52 21.7143Z" fill="#D4C53B"/>' + '</svg></span>',
  nextArrow: '<span class="fain__arrow--next slider__arrow--next"><svg width="52" height="38" viewBox="0 0 52 38" fill="none" xmlns="http://www.w3.org/2000/svg">' + '<path fill-rule="evenodd" clip-rule="evenodd" d="M31.0649 0H24.3117C24.463 6.13429 27.375 11.8804 32.2265 15.6071L32.2643 19.228L32.3129 20.7996L32.2265 22.3929C27.375 26.1196 24.463 31.8657 24.3117 38H31.0649C31.0649 29.3957 40.4655 22.3929 52 22.3929V15.6071C40.4655 15.6071 31.0649 8.60429 31.0649 0Z" fill="#D4C53B"/>' + '<path d="M0 16.2857H32.4156V21.7143H0V16.2857Z" fill="#D4C53B"/>' + '</svg></span>',
  slidesToShow: 3,
  slidesToScroll: 3,
  dots: false,
  infinite: false,
  responsive: [{
    breakpoint: 900,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2
    }
  }, {
    breakpoint: 640,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }]
};
function fainInitSlick() {
  var $slider = jQuery('#fain__results--items');
  if (!$slider.length) return;
  if ($slider.hasClass('slick-initialized')) return;
  $slider.slick(FAIN_SLICK_OPTIONS);
}
function fainRefreshSlick() {
  var $slider = jQuery('#fain__results--items');
  if (!$slider.length) return;
  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('setPosition');
    $slider.slick('refresh');
  }
}
function fainRebuildSlick() {
  var $slider = jQuery('#fain__results--items');
  if (!$slider.length) return;
  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }
  fainInitSlick();
  fainRefreshSlick();
}

/**
 * initMap
 *
 * Renders a Google Map into #map and converts .marker elements into Google markers.
 *
 * @param {HTMLElement|jQuery} global_el Optional element reference.
 * @return {object} Map instance.
 */
function initMap(global_el) {
  var $el;
  if (typeof global_el !== 'undefined' && global_el) {
    $el = global_el.jquery ? global_el : jQuery(global_el);
  } else {
    $el = jQuery('#map');
  }
  if (!$el.length) return null;
  var $markers = jQuery('.marker');
  var hidePOI = [{
    featureType: 'poi',
    elementType: 'labels',
    stylers: [{
      visibility: 'off'
    }]
  }];
  var mapArgs = {
    zoom: $el.data('zoom') || 16,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    styles: hidePOI,
    gestureHandling: 'cooperative',
    zoomControl: true
  };
  var map = new google.maps.Map($el[0], mapArgs);
  var infowindow = new google.maps.InfoWindow();
  map.markers = [];
  $markers.each(function (index) {
    initMarker(jQuery(this), map, index, infowindow);
  });
  centerMap(map);
  var input = document.getElementById('pac-input');
  if (input && google.maps.places && google.maps.places.SearchBox) {
    var searchBox = new google.maps.places.SearchBox(input);
    searchBox.addListener('places_changed', function () {
      searchPlace(map, searchBox);
    });
  }
  global_map = map;
  return map;
}
function centerMap(map) {
  var bounds = new google.maps.LatLngBounds();
  if (!map.markers || !map.markers.length) return;
  map.markers.forEach(function (marker) {
    bounds.extend({
      lat: marker.position.lat(),
      lng: marker.position.lng()
    });
  });
  if (map.markers.length === 1) {
    map.setCenter(bounds.getCenter());
  } else {
    map.fitBounds(bounds);
  }
}
function initMarker($marker, map, index, infowindow) {
  var latRaw = $marker.data('lat');
  var lngRaw = $marker.data('lng');
  var lat = parseFloat(String(latRaw).replace(',', '.'));
  var lng = parseFloat(String(lngRaw).replace(',', '.'));
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
    return;
  }
  var latLng = {
    lat: lat,
    lng: lng
  };
  var icon = {
    url: '/wp-content/themes/wildflowerco/assets/img/location-map.svg',
    size: new google.maps.Size(71, 71),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(17, 34),
    scaledSize: new google.maps.Size(25, 25)
  };
  var marker = new google.maps.Marker({
    position: latLng,
    map: map,
    installer_name: $marker.data('installer-name'),
    industries: $marker.data('industries'),
    project_sizes: $marker.data('project_sizes'),
    id: index,
    icon: icon
  });
  map.markers.push(marker);
  var html = ($marker.html() || '').trim();
  if (html.length) {
    marker.html = html;
    google.maps.event.addListener(marker, 'click', function () {
      infowindow.setContent(marker.html);
      infowindow.open(map, marker);
    });
  }
}
function searchPlace(map, searchBox) {
  var places = searchBox.getPlaces();
  if (!places || places.length === 0) return;
  var bounds = new google.maps.LatLngBounds();
  var closest = [];
  places.forEach(function (place) {
    if (!place.geometry || !place.geometry.location) return;
    var markers = map.markers;
    var icon = {
      url: '/wp-content/themes/wildflowerco/assets/img/location-map-searched.svg',
      size: new google.maps.Size(71, 71),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(17, 34),
      scaledSize: new google.maps.Size(50, 50)
    };
    for (var r = markers.length - 1; r >= 0; r--) {
      if (markers[r].installer_name === 'searched') {
        markers[r].setMap(null);
        markers.splice(r, 1);
      }
    }
    markers.push(new google.maps.Marker({
      map: map,
      icon: icon,
      title: place.name,
      position: place.geometry.location,
      installer_name: 'searched'
    }));
    if (place.geometry.viewport) {
      bounds.union(place.geometry.viewport);
    } else {
      bounds.extend(place.geometry.location);
    }
    closest.length = 0;
    for (var i = 0; i < markers.length; i++) {
      if (!markers[i].getPosition) continue;
      markers[i].distance = google.maps.geometry.spherical.computeDistanceBetween(place.geometry.location, markers[i].getPosition());
      closest.push(markers[i]);
    }
    closest.sort(sortByDist);
    var $items = jQuery('#fain__results--items');
    $items.empty();
    var count = 0;
    closest.forEach(function (marker_object) {
      if (marker_object.installer_name === 'searched') return;
      if (!marker_object.html || !String(marker_object.html).trim()) return;
      $items.append(marker_object.html);
      count++;
    });
    jQuery('#fain__results--count').text(count);
    fainRebuildSlick();
  });
  map.fitBounds(bounds);
  map.setZoom(10);
}
function search_by_installer(map, installer_name) {
  if (!installer_name) return;
  var markers = map.markers || [];
  markers.forEach(function (marker_object) {
    if (marker_object.installer_name !== installer_name) return;
    var $legend = jQuery('#legend');
    if ($legend.length && marker_object.html) {
      $legend.html(marker_object.html);
      map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].clear();
      map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push($legend[0]);
    }
    map.setZoom(12);
    map.panTo(marker_object.getPosition());
    var $items = jQuery('#fain__results--items');
    $items.empty();
    var count = 0;
    if (marker_object.html && String(marker_object.html).trim()) {
      $items.append(marker_object.html);
      count = 1;
    }
    jQuery('#fain__results--count').text(count);
    fainRebuildSlick();
  });
}
function filter_markers(map, category) {
  var markers = map.markers || [];
  for (var i = 0; i < markers.length; i++) {
    var marker = markers[i];
    var industries = marker.industries ? String(marker.industries).split(',') : [];
    var project_sizes = marker.project_sizes ? String(marker.project_sizes).split(',') : [];
    var categories = industries.concat(project_sizes);
    if (!category || category.length === 0 || category.every(function (val) {
      return categories.includes(val);
    })) {
      marker.setVisible(true);
    } else {
      marker.setVisible(false);
    }
  }
}
function sortByDist(a, b) {
  return a.distance - b.distance;
}
function autocomplete(inp, arr) {
  var currentFocus;
  inp.addEventListener('input', function () {
    var a,
      b,
      i,
      val = this.value;
    closeAllLists();
    if (!val) return false;
    currentFocus = -1;
    a = document.createElement('DIV');
    a.setAttribute('id', this.id + 'autocomplete-list');
    a.setAttribute('class', 'autocomplete-items');
    this.parentNode.appendChild(a);
    for (i = 0; i < arr.length; i++) {
      if (arr[i].substr(0, val.length).toUpperCase() === val.toUpperCase()) {
        b = document.createElement('DIV');
        b.innerHTML = '<strong>' + arr[i].substr(0, val.length) + '</strong>';
        b.innerHTML += arr[i].substr(val.length);
        b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";
        b.addEventListener('click', function () {
          inp.value = this.getElementsByTagName('input')[0].value;
          search_by_installer(global_map, inp.value);
          closeAllLists();
        });
        a.appendChild(b);
      }
    }
  });
  inp.addEventListener('keydown', function (e) {
    var x = document.getElementById(this.id + 'autocomplete-list');
    if (x) x = x.getElementsByTagName('div');
    if (e.keyCode === 40) {
      currentFocus++;
      addActive(x);
    } else if (e.keyCode === 38) {
      currentFocus--;
      addActive(x);
    } else if (e.keyCode === 13) {
      e.preventDefault();
      if (currentFocus > -1) {
        if (x) x[currentFocus].click();
      }
    }
  });
  function addActive(x) {
    if (!x) return false;
    removeActive(x);
    if (currentFocus >= x.length) currentFocus = 0;
    if (currentFocus < 0) currentFocus = x.length - 1;
    x[currentFocus].classList.add('autocomplete-active');
  }
  function removeActive(x) {
    for (var i = 0; i < x.length; i++) {
      x[i].classList.remove('autocomplete-active');
    }
  }
  function closeAllLists(elmnt) {
    var x = document.getElementsByClassName('autocomplete-items');
    for (var i = 0; i < x.length; i++) {
      if (elmnt !== x[i] && elmnt !== inp) {
        x[i].parentNode.removeChild(x[i]);
      }
    }
  }
  document.addEventListener('click', function (e) {
    closeAllLists(e.target);
  });
}
jQuery(function ($) {
  fainInitSlick();
  $('.fain__results--tab').on('click', function () {
    var $tab = $(this);
    var theTarget = $tab.attr('data-target');
    $('.fain__results--tab').removeClass('active');
    $('.fain__results--view').removeClass('active');
    $tab.addClass('active');
    $('#' + theTarget).addClass('active');
    if (theTarget === 'fain--map' && window.global_map) {
      window.setTimeout(function () {
        google.maps.event.trigger(global_map, 'resize');
        centerMap(global_map);
      }, 0);
    }
    if (theTarget === 'fain--list') {
      window.setTimeout(function () {
        fainRefreshSlick();
      }, 0);
    }
  });
  $('.filter-map-box-filters li').on('click', function () {
    $(this).toggleClass('checked');
    var $checkbox = $(this).find('input');
    $checkbox.prop('checked', !$checkbox.prop('checked'));
    var categories = [];
    $(this).parents('.filter-map-box-filters').find('input').each(function () {
      if ($(this).prop('checked')) {
        categories.push($(this).val());
      }
    });
    if (window.global_map) {
      filter_markers(global_map, categories);
    }
  });
  var installerInput = document.getElementById('installer-input');
  if (installerInput && typeof installers !== 'undefined' && Array.isArray(installers)) {
    autocomplete(installerInput, installers);
  }
});